import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch, Divider } from 'antd';
import { MuscleGroup, ExerciseDifficultyLevel } from '@wellverse/shared-ts';
import { ExerciseLanguageTabs, normalizeExerciseTranslations } from './LanguageTabs';
import { ExerciseClassificationFields } from './ClassificationFields';

export const ExerciseEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'exercises' });

  return (
    <Edit resource="exercises" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeExerciseTranslations(values.translations, queryResult?.data?.data?.translations),
          })
        }
      >
        <ExerciseLanguageTabs />

        <Divider orientation="left" plain>
          Shared
        </Divider>

        <Form.Item label="Muscle Groups" name="muscleGroups" rules={[{ required: true }]}>
          <Select mode="multiple" placeholder="Select muscle groups">
            {Object.values(MuscleGroup).map((g) => (
              <Select.Option key={g} value={g}>{g}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Difficulty Level" name="difficultyLevel">
          <Select placeholder="Select difficulty">
            {Object.values(ExerciseDifficultyLevel).map((d) => (
              <Select.Option key={d} value={d}>{d}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Video URL" name="videoUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Image URL" name="imageUrl">
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item label="Calories Per Rep" name="caloriesPerRep">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Compound" name="isCompound" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>

        <ExerciseClassificationFields />
      </Form>
    </Edit>
  );
};
